import Vue from 'vue'
import Router from 'vue-router'
import ReplayPage from '../components/ReplayPage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ReplayPage',
      component: ReplayPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js